import httpClient from "../httpClient";
import { API_COMPLICATION_UPDATE } from "../config";

const updateComplicationInfo = {
    updateInfo: (id, data) => httpClient.post(API_COMPLICATION_UPDATE + '/' + id, data),
};

export default updateComplicationInfo;
